import './WhyChooseUs.css';

const ReasonCard = ({ number, title, description }) => (
  <div className="reason-card">
    <div className="reason-number">{number}</div>
    <h3>{title}</h3>
    <p>{description}</p>
  </div>
);

const WhyChooseUs = () => {
  const reasons = [
    {
      number: "1",
      title: "Alta Qualidade",
      description: "Oferecemos painéis de LED de alta qualidade, com resolução excepcional, brilho intenso e cores vibrantes, garantindo um impacto visual impressionante para o seu evento."
    },
    {
      number: "2",
      title: "Versatilidade e Personalização",
      description: "Nossos painéis de LED são versáteis e podem ser personalizados para atender às suas necessidades. Adaptamos o tamanho, a resolução e a configuração para criar a solução ideal para o seu evento."
    },
    {
      number: "3",
      title: "Instalação Profissional",
      description: "Contamos com uma equipe de instalação qualificada e experiente para garantir uma instalação rápida, segura e eficiente. Conte com nosso suporte técnico durante todo o evento."
    },
    {
      number: "4",
      title: "Atendimento Personalizado",
      description: "Oferecemos atendimento personalizado e consultivo para auxiliar na escolha da melhor solução de LED para o seu evento. Nossa equipe está pronta para te auxiliar em cada etapa do processo."
    }
  ];

  return (
    <section className="why-choose-us">
      <div className="section-title">
        <h2>Por que Escolher Nossos Painéis de LED?</h2>
      </div>
      <div className="reasons-grid">
        {reasons.map((reason, index) => (
          <ReasonCard key={index} {...reason} />
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs; 
